module.exports = __webpack_public_path__ + "img/big-picture.f57afbc4.jpg";